//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 08.03.2016.
 */

(function () {

    'use strict';

    angular.module('container.core')
        .config(registerContainer)
        .factory('initService', initService)
        .run(activateContainer);

    function registerContainer(extensionServiceProvider) {
        extensionServiceProvider.addExtension('container.home', 'container', 'fa-dashboard');
    }

    function initService(extensionService, headerService, navigationService, tabBarService, $log) {

        var service = {};

        service.initContainer = function () {

            extensionService.setActiveExtension('container');

            navigationService.addState(1, 'Dashboard', 'dashboard');
        };

        return service;
    }

    function activateContainer(initService) {
        initService.initContainer();
    }
})();